import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FirstUpper } from 'components';
import { T } from 'containers';

import { AppText } from 'domain/appText';

const StyledDiv = styled.div`
  p{
      span{
        margin: 0;
        line-height: 20px;
      }
  }
`;

const PayingCustomer = ({
  firstName,
  lastName,
  title,
  companyName,
  agentContact,
  isAgent,
  isCompany,
  companyReference,
}) => (
  <T
    text={[
      AppText.AgentContactLabel,
      AppText.CompanyReference,
    ]}
    render={([
      agentContactLabel,
      companyReferenceLabel,
    ]) => (
      <StyledDiv>
        <FirstUpper>
          {isCompany
            ? <span>{companyName}</span>
            : <span>{title || ''} {firstName || ''} {lastName || ''}</span>
          }
        </FirstUpper>
        {isCompany && !isAgent && <span>{companyReferenceLabel} {companyReference}</span>}
        {isAgent && <span>{agentContactLabel} {agentContact}</span>}
      </StyledDiv>
  )}
  />
);
PayingCustomer.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  title: PropTypes.string,
  companyName: PropTypes.string,
  agentContact: PropTypes.string,
  customerTitle: PropTypes.string,
  isAgent: PropTypes.bool,
  isCompany: PropTypes.bool,
  companyReference: PropTypes.string,
};

export default PayingCustomer;



// WEBPACK FOOTER //
// ./src/components/molecules/PayingCustomer/index.js